import React, { useState, useEffect } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { useSelector } from 'react-redux';
import { Routes } from "../routes";

// pages
import Presentation from "./Presentation";
import Upgrade from "./Upgrade";
import DashboardOverview from "./dashboard/DashboardOverview";
import AdminDashboard from "./dashboard/AdminDashboard";
import ProfilePage from "./dashboard/ProfilePage";
import Transactions from "./Transactions";
import Settings from "./Settings";
import BootstrapTables from "./tables/BootstrapTables";
import Signin from "./examples/Signin";
import Signup from "./examples/Signup";
import ConfirmRegistration from "./examples/ConfirmRegistration";
import ForgotPassword from "./examples/ForgotPassword";
import ResetPassword from "./examples/ResetPassword";
import Lock from "./examples/Lock";
import NotFoundPage from "./examples/NotFound";
import ServerError from "./examples/ServerError";
import DetailOptionPage from "./dashboard/DetailOptionPage";
import DetailOptionListPage from "./dashboard/DetailOption/DetailOptionListPage";
import ListCiemPage from "./dashboard/Ciem/ListCiemPage";

// documentation pages
import DocsOverview from "./documentation/DocsOverview";
import DocsDownload from "./documentation/DocsDownload";
import DocsQuickStart from "./documentation/DocsQuickStart";
import DocsLicense from "./documentation/DocsLicense";
import DocsFolderStructure from "./documentation/DocsFolderStructure";
import DocsBuild from "./documentation/DocsBuild";
import DocsChangelog from "./documentation/DocsChangelog";

// components
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Preloader from "../components/Preloader";

import Accordion from "./components/Accordion";
import Alerts from "./components/Alerts";
import Badges from "./components/Badges";
import Breadcrumbs from "./components/Breadcrumbs";
import Buttons from "./components/Buttons";
import Forms from "./components/Forms";
import Modals from "./components/Modals";
import Navs from "./components/Navs";
import Navbars from "./components/Navbars";
import Pagination from "./components/Pagination";
import Popovers from "./components/Popovers";
import Progress from "./components/Progress";
import Tables from "./components/Tables";
import Tabs from "./components/Tabs";
import Tooltips from "./components/Tooltips";
import Toasts from "./components/Toasts";
import TeamListPage from "./dashboard/Team/TeamListPage";
import ProductPage from "./dashboard/Product/ProductPage";
import LegalPage from "./dashboard/Product/LegalPage";
import ContributionPage from "./dashboard/Contribution/ContributionPage";
import PerfilMercadoPage from "./dashboard/Demand/PerfilMercadoPage";
import MercadoPotencialPage from "./dashboard/Demand/MercadoPotencialPage";
import MercadoObjetivoPage from "./dashboard/Demand/MercadoObjetivoPage";
import CompetitorPage from "./dashboard/Demand/CompetitorPage";
import MercadoPage from "./dashboard/Demand/MercadoPage";
import MercadoConsumidaPage from "./dashboard/Demand/MercadoConsumidaPage";
import EmpleadoPage from "./dashboard/CostosFijos/EmpleadoPage";
import EmpleadoVentaPage from "./dashboard/CostosFijos/EmpleadoVentaPage";
import EmpleadoDirectoPage from "./dashboard/CostosFijos/EmpleadoDirectoPage";
import EmpleadoIndirectoPage from "./dashboard/CostosFijos/EmpleadoIndirectoPage";
import costosFijosMensual from "./components/CostosFijos/CostosFijosMensual";
import costosFijosMensualPage from "./dashboard/CostosFijos/CostosFijosMensualPage";
import costosSemifijoPage from "./dashboard/CostosFijos/CostosSemifijoPage";
import costosVentasPage from "./dashboard/CostosFijos/CostosVentasPage";
import costosTotalPage from "./dashboard/CostosFijos/CostosTotalPage";
import PeuPage from "./dashboard/CostosFijos/PeuPage";
import CapacidadInstaladaPage from "./dashboard/CostosFijos/CapacidadInstaladaPage";
import InversionSerVivoPage from "./dashboard/Inversion/InversionSerVivoPage";
import InversionMaquinariaPage from "./dashboard/Inversion/InversionMaquinariaPage";
import InversionHerramientaPage from "./dashboard/Inversion/InversionHerramientaPage";
import InversionSoftwarePage from "./dashboard/Inversion/InversionSoftwarePage";
import InversionMueblesPage from "./dashboard/Inversion/InversionMueblesPage";
import InversionComputadorasPage from "./dashboard/Inversion/InversionComputadorasPage";
import InversionVehiculosPage from "./dashboard/Inversion/InversionVehiculosPage";
import InversionPropiedad from "./components/Inversion/InversionPropiedad";
import InversionPropiedadPage from "./dashboard/Inversion/InversionPropiedadPage";
import InversionEstrategicoPage from "./dashboard/Inversion/InversionEstrategicoPage";
import InversionTotalPage from "./dashboard/Inversion/InversionTotalPage";
import InversionCapitalTrabajoPage from "./dashboard/Inversion/InversionCapitalTrabajoPage";
import UserAdministrationPage from "./dashboard/UserAdministrationPage";
import BusinessModelRatingPage from "./dashboard/BusinessModelRatingPage";
import FinanciacionPage from "./dashboard/FinanciacionPage";
import TasaRetornoPage from "./dashboard/TasaRetornoPage";
import CalculoCostoCapitalPage from "./dashboard/CalculoCostoCapitalPage";
import GastosPage from "./dashboard/GastosPage";
import PlanDeNegocioPage from "./dashboard/PlanDeNegocioPage";
import InversoresPage from "./dashboard/InversoresPage";
import SectorExternoPage from "./dashboard/SectorExternoPage";
import EstructuraProduccionPage from "./dashboard/EstructuraProduccionPage";
import EstadoResultadosPage from "./dashboard/EstadoResultadosPage";
import RepresentacionGraficaPage from "./dashboard/Product/RepresentacionGraficaPage";
import CartaIntencionPage from "./dashboard/CartaIntencionPage";
import UserStatsDashboardPage from "./dashboard/UserStatsDashboardPage";
import CiemStatsDashboardPage from "./dashboard/CiemStatsDashboardPage";
import ReportePdfPage from "./dashboard/ReportePdfPage";

const RouteWithLoader = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Route {...rest} render={props => (<> <Preloader show={loaded ? false : true} /> <Component {...props} /> </>)} />
  );
};

const RouteWithSidebar = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const { token } = useSelector(state => state.auth);

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route {...rest} render={props => {
      if (!token) {
        return <Redirect to={Routes.Signin.path} />;
      }

      return (
        <>
          <Preloader show={loaded ? false : true} />
          <Sidebar />

          <main className="content">
            <Navbar />
            <Component {...props} />
            <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
          </main>
        </>
      );
    }}
    />
  );
};

export default () => (
  <Switch>
    <RouteWithLoader exact path={Routes.Presentation.path} component={Presentation} />
    <RouteWithLoader exact path={Routes.Signin.path} component={Signin} />
    <RouteWithLoader exact path={Routes.Signup.path} component={Signup} />
    <RouteWithLoader exact path={Routes.ConfirmRegistration.path} component={ConfirmRegistration} />
    <RouteWithLoader exact path={Routes.ForgotPassword.path} component={ForgotPassword} />
    <RouteWithLoader exact path={Routes.ResetPassword.path} component={ResetPassword} />
    <RouteWithLoader exact path={Routes.Lock.path} component={Lock} />
    <RouteWithLoader exact path={Routes.NotFound.path} component={NotFoundPage} />
    <RouteWithLoader exact path={Routes.ServerError.path} component={ServerError} />

    {/* pages */}
    <RouteWithSidebar exact path={Routes.DashboardOverview.path} component={DashboardOverview} />
    <RouteWithSidebar exact path={Routes.AdminDashboard.path} component={AdminDashboard} />
    <RouteWithSidebar exact path={Routes.Profile.path} component={ProfilePage} />
    <RouteWithSidebar exact path={Routes.Upgrade.path} component={Upgrade} />
    <RouteWithSidebar exact path={Routes.Transactions.path} component={Transactions} />
    <RouteWithSidebar exact path={Routes.Settings.path} component={Settings} />
    <RouteWithSidebar exact path={Routes.BootstrapTables.path} component={BootstrapTables} />
    <RouteWithSidebar exact path={Routes.DetailOptionPage.path} component={DetailOptionPage} />
    <RouteWithSidebar exact path={Routes.ListDetailOptionPage.path} component={DetailOptionListPage} />
    <RouteWithSidebar exact path={Routes.ListCiemPage.path} component={ListCiemPage} />
    <RouteWithSidebar exact path={Routes.ListTeamPage.path} component={TeamListPage} />
    <RouteWithSidebar exact path={Routes.ListProductPage.path} component={ProductPage} />
    <RouteWithSidebar exact path={Routes.LegalPage.path} component={LegalPage} />
    <RouteWithSidebar exact path={Routes.ContributionPage.path} component={ContributionPage} />
    <RouteWithSidebar exact path={Routes.PerfilMercadoPage.path} component={PerfilMercadoPage} />
    <RouteWithSidebar exact path={Routes.MercadoPotencialPage.path} component={MercadoPotencialPage} />
    <RouteWithSidebar exact path={Routes.MercadoObjetivoPage.path} component={MercadoObjetivoPage} />
    <RouteWithSidebar exact path={Routes.CompetitorPage.path} component={CompetitorPage} />
    <RouteWithSidebar exact path={Routes.MercadoPage.path} component={MercadoPage} />
    <RouteWithSidebar exact path={Routes.MercadoConsumidaPage.path} component={MercadoConsumidaPage} />
    <RouteWithSidebar exact path={Routes.EmpleadoPage.path} component={EmpleadoPage} />
    <RouteWithSidebar exact path={Routes.EmpleadoVentaPage.path} component={EmpleadoVentaPage} />
    <RouteWithSidebar exact path={Routes.EmpleadoDirectoPage.path} component={EmpleadoDirectoPage} />
    <RouteWithSidebar exact path={Routes.EmpleadoIndirectoPage.path} component={EmpleadoIndirectoPage} />
    <RouteWithSidebar exact path={Routes.CostosFijosMensualPage.path} component={costosFijosMensualPage} />
    <RouteWithSidebar exact path={Routes.CostosSemifijoPage.path} component={costosSemifijoPage} />
    <RouteWithSidebar exact path={Routes.CostosVentasPage.path} component={costosVentasPage} />
    <RouteWithSidebar exact path={Routes.CostosTotalPage.path} component={costosTotalPage} />
    <RouteWithSidebar exact path={Routes.PeuPage.path} component={PeuPage} />
    <RouteWithSidebar exact path={Routes.CapacidadInstaladaPage.path} component={CapacidadInstaladaPage} />
    <RouteWithSidebar exact path={Routes.InversionSerVivoPage.path} component={InversionSerVivoPage} />
    <RouteWithSidebar exact path={Routes.InversionMaquinariaPage.path} component={InversionMaquinariaPage} />
    <RouteWithSidebar exact path={Routes.InversionHerramientaPage.path} component={InversionHerramientaPage} />
    <RouteWithSidebar exact path={Routes.InversionSoftwarePage.path} component={InversionSoftwarePage} />
    <RouteWithSidebar exact path={Routes.InversionMueblesPage.path} component={InversionMueblesPage} />
    <RouteWithSidebar exact path={Routes.InversionComputadorasPage.path} component={InversionComputadorasPage} />
    <RouteWithSidebar exact path={Routes.InversionVehiculosPage.path} component={InversionVehiculosPage} />
    <RouteWithSidebar exact path={Routes.InversionPropiedadPage.path} component={InversionPropiedadPage} />
    <RouteWithSidebar exact path={Routes.InversionEstrategicoPage.path} component={InversionEstrategicoPage} />
    <RouteWithSidebar exact path={Routes.InversionTotalPage.path} component={InversionTotalPage} />
    <RouteWithSidebar exact path={Routes.InversionCapitalTrabajoPage.path} component={InversionCapitalTrabajoPage} />
    <RouteWithSidebar exact path={Routes.UserAdministrationPage.path} component={UserAdministrationPage} />
    <RouteWithSidebar exact path={Routes.BusinessModelRatingPage.path} component={BusinessModelRatingPage} />
    <RouteWithSidebar exact path={Routes.FinanciacionPage.path} component={FinanciacionPage} />
    <RouteWithSidebar exact path={Routes.TasaRetornoPage.path} component={TasaRetornoPage} />
    <RouteWithSidebar exact path={Routes.CalculoCostoCapitalPage.path} component={CalculoCostoCapitalPage} />
    <RouteWithSidebar exact path={Routes.GastosPage.path} component={GastosPage} />
    <RouteWithSidebar exact path={Routes.PlanDeNegocioPage.path} component={PlanDeNegocioPage} />
    <RouteWithSidebar exact path={Routes.InversoresPage.path} component={InversoresPage} />
    <RouteWithSidebar exact path={Routes.SectorExternoPage.path} component={SectorExternoPage} />
    <RouteWithSidebar exact path={Routes.EstructuraProduccionPage.path} component={EstructuraProduccionPage} />
    <RouteWithSidebar exact path={Routes.EstadoResultadosPage.path} component={EstadoResultadosPage} />
    <RouteWithSidebar exact path={Routes.RepresentacionGraficaPage.path} component={RepresentacionGraficaPage} />
    <RouteWithSidebar exact path={Routes.CartaIntencionPage.path} component={CartaIntencionPage} />
    <RouteWithSidebar exact path={Routes.UserStatsDashboard.path} component={UserStatsDashboardPage} />
    <RouteWithSidebar exact path={Routes.CiemStatsDashboard.path} component={CiemStatsDashboardPage} />
    <RouteWithSidebar exact path={Routes.ReportePdfPage.path} component={ReportePdfPage} />

    {/* components */}
    <RouteWithSidebar exact path={Routes.Accordions.path} component={Accordion} />
    <RouteWithSidebar exact path={Routes.Alerts.path} component={Alerts} />
    <RouteWithSidebar exact path={Routes.Badges.path} component={Badges} />
    <RouteWithSidebar exact path={Routes.Breadcrumbs.path} component={Breadcrumbs} />
    <RouteWithSidebar exact path={Routes.Buttons.path} component={Buttons} />
    <RouteWithSidebar exact path={Routes.Forms.path} component={Forms} />
    <RouteWithSidebar exact path={Routes.Modals.path} component={Modals} />
    <RouteWithSidebar exact path={Routes.Navs.path} component={Navs} />
    <RouteWithSidebar exact path={Routes.Navbars.path} component={Navbars} />
    <RouteWithSidebar exact path={Routes.Pagination.path} component={Pagination} />
    <RouteWithSidebar exact path={Routes.Popovers.path} component={Popovers} />
    <RouteWithSidebar exact path={Routes.Progress.path} component={Progress} />
    <RouteWithSidebar exact path={Routes.Tables.path} component={Tables} />
    <RouteWithSidebar exact path={Routes.Tabs.path} component={Tabs} />
    <RouteWithSidebar exact path={Routes.Tooltips.path} component={Tooltips} />
    <RouteWithSidebar exact path={Routes.Toasts.path} component={Toasts} />

    {/* documentation */}
    <RouteWithSidebar exact path={Routes.DocsOverview.path} component={DocsOverview} />
    <RouteWithSidebar exact path={Routes.DocsDownload.path} component={DocsDownload} />
    <RouteWithSidebar exact path={Routes.DocsQuickStart.path} component={DocsQuickStart} />
    <RouteWithSidebar exact path={Routes.DocsLicense.path} component={DocsLicense} />
    <RouteWithSidebar exact path={Routes.DocsFolderStructure.path} component={DocsFolderStructure} />
    <RouteWithSidebar exact path={Routes.DocsBuild.path} component={DocsBuild} />
    <RouteWithSidebar exact path={Routes.DocsChangelog.path} component={DocsChangelog} />

    <Redirect to={Routes.NotFound.path} />
  </Switch>
);
